<template>
  <div class="container">
    <div class="title">
      <div class="back" @click="back">
        <div class="back-arr">
          <div class="back-arr-top"></div>
          <div class="back-arr-bottom"></div>
        </div>
        <div class="back-txt">返回</div>
      </div>
      切换地址
    </div>
    <el-table :data="list" style="width: 100%">
      <el-table-column prop="key" label="地址" />
      <el-table-column width="200px" label="操作">
        <template #default="scope">
          <el-button
            type="primary"
            size="mini"
            @click="goTo(scope.$index, scope.row)"
            >前往</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
    };
  },
  async mounted() {
    try {
      let res = await this.$myRequest({
        url: "/getPlDeviceListReqAction",
        method: "post",
      });
      res = res.data;
      this.list = res.data;
    } catch (err) {
      console.log(err);
    }
  },
  methods: {
    goTo(index, row) {
      // window.location.href = row.value + "index.html";
      window.open(row.value + "index.html");
    },
    back() {
      this.$router.back();
    },
  },
};
</script>

<style scoped lang="less" src="./index.less"></style>
<style>
.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background-color: #204ca3 !important;
}
</style>
